<template>
    <div id="cashOutSuccess">
        <Headers :headersText='headersText'></Headers>
        <img src="../assets/images/img_28.png" alt="" id="successIcon">
        <div class="successText">
            <div>恭喜你提现成功</div>
            <div><span>+</span><span>{{cash_amount}} </span>元</div>
        </div>
        <div class="sucBtn" @click="inIndex">继续做任务</div>

        <div class="explain">将于次日 24:00 之前到账</div>
    </div>
</template>

<script>
    import Headers from '../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'提现申请成功',
                cash_amount:''
            }
        },
        mounted() {
            console.log(this.$route.query.cash_amount)
            this.cash_amount = this.$route.query.cash_amount.toFixed(2);
        },
        methods: {
            // 进入 首页
            inIndex:function(){
                this.$router.push('/fastTasks');
            }
        },
    }
</script>

<style lang="less" scoped>
    #cashOutSuccess{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        #successIcon{
            width: 88px;
            height: 75px;
            margin: 97px 0 25px;
        }
        .successText{
            div{
                text-align: center;
                &:nth-of-type(1){
                    color: #1E1E1E;
                    font-size: 15px;
                    font-weight: bold;
                }
                &:nth-of-type(2){
                    color: #333333;
                    font-size: 14px;
                    margin: 12px 0 15px;
                    span{
                        font-weight: bold;
                        &:nth-of-type(1){
                            font-size: 20px;
                        }
                        &:nth-of-type(2){
                            font-size: 24px;
                        }
                    }
                }
            }
        }
        .sucBtn{
            width: 335px;
            height: 50px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            border-radius: 25px;
            color: #FFFFFF;
            font-size: 15px;
            text-align: center;
            line-height: 50px;
            box-shadow: 0 5px 10px rgba(229, 1, 19, .15);
            margin-top: 40px;
        }

        .explain{
            color: #999999;
            font-size: 13px;
            margin-top: 50px;
        }
    }
</style>